import { message } from 'antd';
import FileRepository from 'services/api-repositories/files/FileRepository';
import { openErrorNotification } from 'hyarchis-global/components/notifications';
import { AxiosError } from 'axios';

export default (fileId: string, fullName = 'file.pdf') =>
  async () => {
    message.success(`Downloading ${fullName}...`, 1);
    let fileContent;
    try {
      fileContent = await FileRepository.get(fileId);
    } catch (error) {
      openErrorNotification((error as AxiosError).message);
    }

    if (fileContent) {
      const url = window.URL.createObjectURL(fileContent);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fullName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };
